if (!customElements.get('wls-s-ingredients-tabs')) {
  class WLS_S_IngredientsTabs extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        tab: 'js-wls-s-ingredients-tabs-tab',
        group: 'js-wls-s-ingredients-tabs-group',
        active: 'active',
      };
      this.selectors = {
        tabs: this.querySelectorAll(`.${this.classes.tab}`),
        groups: this.querySelectorAll(`.${this.classes.group}`),
      };
    }

    connectedCallback() {
      this.bindEvents();
    }

    bindEvents() {
      this.selectors.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick.bind(this));
      });
    }

    handleTabClick(e) {
      e.preventDefault();
      const tabIndex = e.currentTarget.dataset.tabsTab;
      this.selectors.tabs.forEach((tab) => {
        tab.classList.remove(this.classes.active);
      });
      this.selectors.groups.forEach((group) => {
        group.classList.remove(this.classes.active);
      });
      e.currentTarget.classList.add(this.classes.active);
      this.selectors.groups[tabIndex].classList.add(this.classes.active);
    }
  }
  
  customElements.define('wls-s-ingredients-tabs', WLS_S_IngredientsTabs);
}
